import { render } from "./BranchAuditSection.vue?vue&type=template&id=35624e0e&scoped=true"
import script from "./BranchAuditSection.vue?vue&type=script&lang=js"
export * from "./BranchAuditSection.vue?vue&type=script&lang=js"

import "./BranchAuditSection.vue?vue&type=style&index=0&id=35624e0e&scoped=true&lang=css"

import exportComponent from "C:\\All Projects\\Digital Sinage Main\\Digital Sinage Admin\\media-device-frontend\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35624e0e"]])

export default __exports__